import createContextFactory from "@Utils/factory"

import { useGridTable } from "./hooks"

const { Provider, useContext } = createContextFactory(useGridTable)

export {
  useContext as useTableContext,
  Provider as TableProvider,
}
